export const REFRESH_INTERVAL_MS = 30 * 1000

export const EXPORT_RECORD_LIMIT = 1000

export const INJECT_QUERY_PROVIDER = 'analytics-query-provider'
